import React from 'react';
import { Shield, FileText, PlayCircle, ExternalLink } from 'lucide-react';
import { useSiteContent } from '../context/SiteContentContext';

const iconMap = { Shield, FileText, PlayCircle };

const SupportSection = () => {
  const { supportItems } = useSiteContent();
  if (!supportItems || supportItems.length === 0) return null;

  return (
    <section id="support" className="py-16 lg:py-24 bg-gradient-to-b from-blue-50/40 to-white" data-testid="support-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <p className="text-sm font-semibold text-[#0a3d8f] uppercase tracking-widest mb-2">Layanan Purna Jual</p>
          <h2 className="text-3xl lg:text-4xl font-extrabold text-gray-900">Dukungan Teknis JILONG</h2>
          <div className="section-divider"></div>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {supportItems.map((s) => {
            const Icon = iconMap[s.icon] || Shield;
            return (
              <a
                key={s.id}
                href={s.link || '#contact'}
                target={s.link ? '_blank' : undefined}
                rel="noreferrer"
                data-testid={`support-${s.id}`}
                className="group bg-white rounded-2xl p-7 border border-gray-100 shadow-md hover:shadow-xl hover:-translate-y-1 transition-all"
              >
                <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-[#0a3d8f] to-[#0a8f3d] text-white flex items-center justify-center mb-5 shadow-lg">
                  <Icon size={26} />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-1 font-[Montserrat]">{s.title}</h3>
                <p className="text-xs uppercase tracking-wider text-[#0a3d8f] font-semibold mb-3">{s.titleId}</p>
                <p className="text-sm text-gray-600 leading-relaxed line-clamp-3 mb-4">{s.description}</p>
                <div className="inline-flex items-center gap-2 text-sm font-semibold text-[#0a3d8f] group-hover:text-[#082e6b]">
                  <span>Buka Halaman</span>
                  <ExternalLink size={14} className="transition-transform group-hover:translate-x-0.5" />
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default SupportSection;
